import styled from 'vue-styled-components'
import colors from '~/components/kit/theme'

const componentProps = {
  fill: String,
  size: {
    type: String,
    default: '24px'
  },
  width: String,
  height: String
}

const StyledSvg = styled('span', componentProps)`
  &.ico {
    width: ${(props) => (props.width ? props.width : props.size)};
    height: ${(props) => (props.height ? props.height : props.size)};
    fill: ${(props) =>
      props.fill
        ? colors.knownColor(props.fill)
          ? colors.knownColor(props.fill)
          : ''
        : ''};

    use,
    use + *,
    * {
      fill: ${(props) =>
        props.fill
          ? colors.knownColor(props.fill)
            ? colors.knownColor(props.fill)
            : ''
          : ''};
    }
  }
`

export default StyledSvg
